import React, { useState } from "react";
import ModalBottom from "./ModalBottom";
import Button from "../Button/Button";
import { formatRupiah, toastNotify } from "../../utils/Utils";
import { ReactComponent as PlusIcon } from "../../assets/icons/plus.svg";
import { ReactComponent as ImageIcon } from "../../assets/icons/image-multiple.svg";
import { ReactComponent as DocIcon } from "../../assets/icons/document.svg";
import _ from "lodash";
import ModalImage from "../ModalImage";
import moment from "moment";

const ModalDcmUpload = ({
  showModal,
  setShowModal,
  data,
  setData,
  uploadedImages,
  setUploadedImages,
  actualizationData,
  AddData,
}) => {
  const [loadingBalance, setLoadingBalance] = useState(false);
  const [showModalImage, setShowModalImage] = useState(false);
  const [image, setImage] = useState(null);

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files); // Convert FileList to an array
    const maxSize = 5 * 1024 * 1024; // 5 MB size limit
    const filteredFiles = files.filter((file) => {
      const isImage = file.type.startsWith("image/");

      // Allow all images regardless of size
      if (isImage) return true;

      // Reject non-image files over 5MB
      if (file.size > maxSize) {
        toastNotify(`File ${file.name} exceeds the 5 MB size limit.`, "error");
        return false;
      }

      return true;
    });

    const newImages = filteredFiles.map((file) => ({
      url: URL.createObjectURL(file),
      name: file.name,
      type: file.type,
    }));
    setUploadedImages((prevImages) => [...prevImages, ...newImages]); // Add new images to the state

    e.target.value = "";
  };

  const removeImage = (index) => {
    setUploadedImages(
      (prevImages) => prevImages.filter((_, i) => i !== index), // Remove image by index
    );
  };

  return (
    <>
      <ModalImage
        modalOpen={showModalImage}
        setModalOpen={setShowModalImage}
        image={image}
      />
      <ModalBottom
        showModal={showModal}
        setShowModal={setShowModal}
        onClose={() => {
          setShowModal(false);
          setUploadedImages([]);
        }}
        defaultHeight={0.9}
        title="Riwayat Pengajuan"
        footer={
          <div className="">
            <div className="grid grid-cols-2 space-x-2">
              <Button
                onClick={() => {
                  setShowModal(false);
                }}
                fullWidth
                size="sm"
                label="Kembali"
                variant="default"
              />
              <Button
                label="Simpan"
                fullWidth
                size="sm"
                disabled={data.typeModal === "view"}
                variant="gradient"
                onClick={AddData}
              />
            </div>
          </div>
        }
      >
        <div className="space-y-7">
          {data.typeModal === "add" && (
            <>
              <div className="text-sm">
                <input
                  name="amount"
                  placeholder="Rp. 0"
                  className={`form-input mb-0.5 mt-1.5 h-12 w-full font-semibold disabled:bg-gray-100 ${
                    data.amount > data?.balance && "border-2 border-red-500"
                  }`}
                  disabled={data.typeModal === "view" || data.balance === 0}
                  type="text"
                  value={
                    data.amount
                      ? formatRupiah(data.amount?.toString(), "Rp. ")
                      : ""
                  }
                  onChange={(e) => {
                    let value = _.isEmpty(e.target.value?.replace(/[^\d]/g, ""))
                      ? 0
                      : e.target.value?.replace(/[^\d]/g, "");
                    if (parseInt(value) <= parseInt(data?.balance)) {
                      setData((prevState) => ({
                        ...prevState,
                        amount: value,
                      }));
                    } else if (parseInt(value) > parseInt(data?.balance)) {
                      setData((prevState) => ({
                        ...prevState,
                        amount: data?.balance,
                      }));
                    }
                  }}
                />
                <div className="mt-2 flex items-center justify-between">
                  <div className="text-xs text-gray-400">Saldo </div>
                  <div className="flex items-center space-x-1 text-xs font-medium text-gray-600">
                    {loadingBalance ? (
                      <div className="h-3 w-24 animate-pulse rounded bg-gray-200"></div>
                    ) : (
                      <div>
                        {formatRupiah(data?.balance?.toString(), "Rp. ")}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex w-full flex-col items-center rounded-lg border-1.5 border-dashed border-gray-200 p-4">
                {_.isEmpty(uploadedImages) ? (
                  <label
                    htmlFor="file-upload"
                    className="flex w-full cursor-pointer flex-col items-center space-y-3"
                  >
                    <DocIcon className="h-12 w-12 text-gray-400" />
                    <input
                      id="file-upload"
                      type="file"
                      className="hidden"
                      accept="image/*,application/pdf" // Accept images and PDFs
                      multiple // Allow multiple file uploads
                      onChange={handleFileUpload}
                    />
                    <p className="text-xs font-bold text-blue-500">
                      Tambah File
                    </p>
                    <p className="text-center text-xs text-gray-400">
                      File yang didukung: .jpg .png .pdf <br /> maks. 5 MB.
                    </p>
                  </label>
                ) : (
                  <div className="grid w-full grid-cols-3 gap-2">
                    {uploadedImages.map((file, index) => (
                      <div key={index} className="relative">
                        {file.type?.startsWith("image/") ? (
                          <img
                            src={file.url}
                            onClick={() => {
                              setImage(file.url);
                              setShowModalImage(true);
                            }}
                            alt={`Uploaded ${index}`}
                            className="h-24 w-full rounded-md object-cover"
                          />
                        ) : (
                          <a
                            href={file.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <div className="flex h-24 w-full flex-col items-center justify-center gap-1 rounded-md bg-gray-100">
                              <DocIcon className="h-8 w-8 text-gray-400" />
                              <span className="text-3xs text-blue-500">
                                {file.name.substring(0, 10)}...
                              </span>
                            </div>
                          </a>
                        )}
                        {!file?.url?.startsWith("https://cdn.kar-tini.id/") &&
                          data.typeModal === "add" && (
                            <button
                              onClick={() => removeImage(index)}
                              className="absolute right-1 top-0.5 text-xs text-white"
                            >
                              <PlusIcon className="h-5 w-5 rotate-45 rounded-full bg-transparent-black-40" />
                            </button>
                          )}
                      </div>
                    ))}
                    {data.typeModal === "add" && (
                      <div className="flex h-24 w-full items-center justify-center rounded-md border border-dashed bg-gray-200 object-cover">
                        <label htmlFor="file-upload" className="">
                          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-400 text-center text-white">
                            <PlusIcon />
                          </div>
                          <input
                            id="file-upload"
                            type="file"
                            className="hidden"
                            accept="image/*,application/pdf" // Accept images and PDFs
                            multiple // Allow multiple file uploads
                            onChange={handleFileUpload}
                          />
                        </label>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </>
          )}
          {!_.isEmpty(actualizationData) ? (
            [...actualizationData]
              .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
              .map((item, index) => (
                <>
                  <div className="text-sm" key={index}>
                    <p className="text-sm text-gray-400 ">
                      {moment(item.createdAt).local().format("DD MMM YY HH:mm")}
                    </p>
                    <input
                      name="amount"
                      placeholder="Rp. 0"
                      className={`form-input mb-0.5 mt-1.5 h-12 w-full font-semibold disabled:bg-gray-100 ${
                        data.amount > data?.balance && "border-2 border-red-500"
                      }`}
                      disabled
                      type="text"
                      value={
                        item.amount
                          ? formatRupiah(item.amount?.toString(), "Rp. ")
                          : ""
                      }
                    />
                  </div>
                  <div className="flex w-full flex-col items-center rounded-lg border-1.5 border-dashed border-gray-200 p-4">
                    {!_.isEmpty(item.documents) && (
                      <div className="grid w-full grid-cols-3 gap-2">
                        {item.documents.map((doc, idx) =>
                          doc.key?.includes("IMAGE") ? (
                            <div key={idx} className="relative">
                              <img
                                src={doc.value}
                                onClick={() => {
                                  setImage(doc.value);
                                  setShowModalImage(true);
                                }}
                                alt={`Uploaded ${index}`}
                                className="h-24 w-full rounded-md object-cover"
                              />
                            </div>
                          ) : (
                            <a
                              href={doc.value}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <div className="flex h-24 w-full flex-col items-center justify-center gap-1 rounded-md bg-gray-100">
                                <DocIcon className="h-8 w-8 text-gray-400" />
                                <span className="text-3xs text-blue-500">
                                  {doc.value.substring(0, 10)}...
                                </span>
                              </div>
                            </a>
                          ),
                        )}
                      </div>
                    )}
                  </div>
                </>
              ))
          ) : (
            <div className="flex flex-col items-center justify-center gap-2 text-sm text-gray-400">
              <DocIcon className="h-12 w-12 text-gray-400" />
              <p className="text-xs">Tidak ada riwayat pengajuan</p>
            </div>
          )}
        </div>
      </ModalBottom>
    </>
  );
};

export default ModalDcmUpload;
